import React, { useState } from 'react'
import ReturnHeader from '../../components/returnHeader'
import { fake } from '../../faker'
import { Link, useNavigate } from 'react-router-dom'
import { angelRight, chemistry, commentDots, crypto, likeVideo, player, searchs, trash, videoIcon } from '../../assets'
import { Button } from '../../components/Generic'

const Toplam = () => {
    const [isChildValueFalse, setIsChildValueFalse] = useState('');
    const [data, setData] = useState(fake);
    const [dotsfalse, setDotsfalse] = useState();

    const handleChildValueChange = (newValue) => {
        setIsChildValueFalse(newValue);
      };
    const fileType='video'
    const content = [
      {
        icon: searchs,
        text: "Izlash",
        action: "search",
      },
      {
        icon: trash,
        text: "O’chirish",
        action: "delete",
      },
    ];

    const handleCheckboxChange = (itemId) => {
        // Create a new copy of the data array
        const updatedData = data.map((item) => {
          if (item.id === itemId) {
            // Toggle the checked property for the clicked item
            return { ...item, checked: !item.checked };
          }
          return item;
        });
    
        // Update the state with the new data
        setData(updatedData);
      };
    
        const checked = data.filter((item) => item.checked).length
    const navigate = useNavigate()
    const handleIsClick = (clickedItem) => {
      setDotsfalse(false)
      console.log(dotsfalse, "bu nima")
      setIsChildValueFalse(clickedItem.action)
      // setClickedObject(clickedItem);
      // onChildValueChange(()=>isChildValueFalse===clickedObject.action ? '' : clickedObject.action);
    };
    
  const handleClear =()=>{
    setIsChildValueFalse('')
    checked.length = 0
  }
  const handleIsClear =()=>{
    setIsChildValueFalse('')
  }
  return (
    <div>
              <ReturnHeader
        styles={isChildValueFalse === "search" ? `w-full max-w-[700px]` : false}
        page={
          isChildValueFalse === "search" ? (
            <div className="">
              <div className="rounded-[12px]  bg-white z-[15]  items-center flex w-full h-[48px]">
                <div className="pl-[16px] pr-[12px]">
                  <img
                    className="opacity-40 w-[24px] h-[24px]"
                    src={searchs}
                    alt=""
                  />
                </div>
                <input
                  className="outline-none border-none sm:text-[18px] text-gray-usersGray bg-inherit w-full"
                  type="text"
                  placeholder="what you want to learn?"
                />
              </div>
            </div>
          ) : (
            "To'plam"
          )
        }
        onClick={() => navigate(-1)}
        onChildValueChange={handleChildValueChange}
        content={content}
      >
        {content &&
            content.map((item)=>(
              <Link to={item.path}
              onClick={() => handleIsClick(item)}
              className="flex hover:bg-slate-100 cursor-pointer h-[26px] sm:h-[30px] justify-start gap-5 items-center	p-1.5	md:p-3"
              >
            <div><img className="w-[12px] h-[12px]" src={item.icon} alt="" /></div>
            <div className="text-[13px] md:text-[16px]">{item.text}</div>
          </Link>
            ))}
      </ReturnHeader>
      {
        isChildValueFalse==='search' ||
        <div className='flex justify-center mt-[-13px]'>
            <div className='text-gray-lightlyGray ml-[20px]  text-[15px]'>soni {fake.length} ta</div>
        </div>
        }
        <div>
            <div className='mt-[30px] flex gap-[16px] w-full flex-wrap'>
            { fake.map((item)=>(

              <div key={item.length} className='flex mx-[30px] w-full justify-between max-w-[344px] sm:max-w-[450px] items-center'>
                <Link to='/toplamlar'  className='flex items-center  gap-[22px]'>
                <div className='flex justify-center relative items-center rounded-[10px] w-[90px] h-[83px] sm:w-[160] overflow-hidden'>
                    <img className='h-full' src={chemistry} alt="no data" />
                    {
                      fileType==='video' &&
                    <img className='absolute top-[40%] left-[35%] w-[26px] h-[26px]' src={player} alt="" />
                    }
                </div>
                <div>
                    <div className='flex gap-[9px] items-center'>
                        <div className='w-[110px] sm:h-[34px] h-[22px] overflow-hidden relative shadow-whiteShadow'>
                        <div className='text-[18px] w-full whitespace-nowrap absolute font-normal sm:text-[20px]'>Matematika</div>
                        <div className='h-[50px] absolute right-[0] top-0  w-[60px] shadow-whiteShadow'></div>
                        </div>                            
                        <div className='text-[12px] sm:text-[15px] font-[Poppins] cursor-pointer text-gray-lightlyGray'> Videos</div>
                        <div><img src={videoIcon} alt="" /></div>
                    </div>
                    <div className='text-[10px] sm:text-[14px] gap-[19px] flex items-center  font-[Poppins]'>
                      <div className='flex gap-[5px] items-center'>
                      <img src={likeVideo} alt="" />
                      <div className='text-blue-likeBlue'>785</div>
                      </div> 
                      <div className='flex gap-[5px] items-center'>
                      <img src={crypto} alt="" />
                      <div className='text-gray-lightlyGray'>1k+</div>
                      </div>
                      <div className='flex gap-[5px] items-center'>
                      <img src={commentDots} alt="" />
                      <div className='text-gray-lightlyGray'>850+</div>
                      </div>
                    </div>
                </div>
                </Link>
                <div className='cursor-pointer'>
                    {
                        isChildValueFalse==='delete' ? 
                        <div><input type="checkbox" checked={item.checked} onChange={() => handleCheckboxChange(item.id)} name="" id="" /></div> :
                    <Link to='/about'>
                    <img src={angelRight} alt="" />
                    </Link>
                    }
                </div>
              </div>
                ))}

            </div>
            <div className='flex relative justify-center '>
            <div className='fixed flex justify-center bottom-20 sm:bottom-10'>
            {isChildValueFalse==='delete' &&
              <div className="flex justify-center flex-wrap gap-[10px]">
                <Button style={`w-[360px] bg-blue`} value={`Delete ${checked} items`}/>
              <Button onClick={handleClear} styl={'text-black-userBlack'} style={`w-[360px] bg-white text-black-userBlack shadow-blackShadow`} val={`Cancel`} />
              </div>
            }
            {isChildValueFalse === 'search' && (
              <Button onClick={handleIsClear} styl={'text-black-userBlack'} style={`w-[360px] bg-white  shadow-blackShadow`} val={`Cancel`} />
              )}
            </div>
            </div>
        </div>
    </div>
  )
}

export default Toplam